export const CAMPAIGN_REASON = {
  COPA60: 'TRIVIA-COPA-60',
  DEJALIR: 'DEJALA-IR'
};
